// *** Angular
import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';

// *** Packages
import {
   ApexAxisChartSeries,
   ApexChart,
   ApexTitleSubtitle,
   ApexXAxis,
} from 'ng-apexcharts';
import { NgxSpinnerService } from 'ngx-spinner';

// *** Services
import { AdministratorStatisticsService } from 'src/app/services/administrator-statistics.service';

export type ChartOptions = {
   series: ApexAxisChartSeries;
   chart: ApexChart;
   xaxis: ApexXAxis;
   title: ApexTitleSubtitle;
   labels: string[];
};

@Component({
   selector: 'app-thesis-institutional',
   templateUrl: './thesis-institutional.component.html',
   styleUrls: ['./thesis-institutional.component.scss'],
})
export class ThesisInstitutionalComponent implements OnInit {
   /**
    * Variabel used to store data that are shown on chart
    */
   institutionThesisData: any;
   /**
    * Variabel used to store options for chart
    */
   chartOptions = {
      series: [
         {
            name: 'Bachelor',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
         },
         {
            name: 'Master',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
         },
         {
            name: 'Ph.D.',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
         },
      ],
      colors: ['#F44336', '#E91E63', '#9C27B0'],
      chart: {
         height: 350,
         type: 'line',
         zoom: {
            enabled: true,
         },
      },
      dataLabels: {
         enabled: true,
         style: {
            colors: ['#F44336', '#E91E63', '#9C27B0'],
         },
      },
      title: {
         text: 'Theses',
         align: 'center',
      },
      xaxis: {
         categories: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
         ],
      },
      grid: {
         borderColor: '#f1f1f1',
      },
   };
   /**
    * Variabel used to store current year
    */
   year: number;
   lastFourYears: number[] = [];
   availableYears: number[] = [];
   constructor(
      private statistics: AdministratorStatisticsService,
      private spinner: NgxSpinnerService
   ) {}

   ngOnInit(): void {
      this.year = new Date().getFullYear();
      this.lastFourYears = Array.from({ length: 5 }, (_, index) => this.year - index);
      this.availableYears = this.lastFourYears.reverse();

      this.statistics
         .institutionThesisSubmissionsStatistics(this.year)
         .pipe(first())
         .subscribe(
            (data) => {
               this.institutionThesisData = data;

               this.chartOptions = {
                  series: [
                     {
                        name: 'Bachelor',
                        data: data.submittedBachelor,
                     },
                     {
                        name: 'Master',
                        data: data.submittedMaster,
                     },
                     {
                        name: 'Ph.D.',
                        data: data.submittedPhD,
                     },
                  ],
                  colors: ['#F44336', '#E91E63', '#9C27B0'],
                  chart: {
                     height: 350,
                     type: 'line',
                     zoom: {
                        enabled: true,
                     },
                  },
                  dataLabels: {
                     enabled: true,
                     style: {
                        colors: ['#F44336', '#E91E63', '#9C27B0'],
                     },
                  },
                  title: {
                     text: 'Theses',
                     align: 'center',
                  },
                  xaxis: {
                     categories: [
                        'January',
                        'February',
                        'March',
                        'April',
                        'May',
                        'June',
                        'July',
                        'August',
                        'September',
                        'October',
                        'November',
                        'December',
                     ],
                  },
                  grid: {
                     borderColor: '#f1f1f1',
                  },
               };
            },
            (error) => {
               console.log('error', error);
            }
         );
   }
   /**
    * Function is used to filter statitistics by year
    * @param value
    */
   filterByYear(value) {
      this.spinner.show();
      this.year = parseInt(value);
      this.statistics
         .institutionThesisSubmissionsStatistics(this.year)
         .pipe(first())
         .subscribe(
            (data) => {
               this.institutionThesisData = data;

               this.chartOptions = {
                  series: [
                     {
                        name: 'Bachelor',
                        data: this.institutionThesisData.submittedBachelor,
                     },
                     {
                        name: 'Master',
                        data: this.institutionThesisData.submittedMaster,
                     },
                     {
                        name: 'Ph.D.',
                        data: this.institutionThesisData.submittedPhd,
                     },
                  ],
                  colors: ['#F44336', '#E91E63', '#9C27B0'],
                  chart: {
                     height: 350,
                     type: 'line',
                     zoom: {
                        enabled: true,
                     },
                  },
                  dataLabels: {
                     enabled: true,
                     style: {
                        colors: ['#F44336', '#E91E63', '#9C27B0'],
                     },
                  },
                  title: {
                     text: 'Theses',
                     align: 'center',
                  },
                  xaxis: {
                     categories: [
                        'January',
                        'February',
                        'March',
                        'April',
                        'May',
                        'June',
                        'July',
                        'August',
                        'September',
                        'October',
                        'November',
                        'December',
                     ],
                  },
                  grid: {
                     borderColor: '#f1f1f1',
                  },
               };
               this.spinner.hide();
            },
            (error) => {
               this.spinner.hide();
               console.log('error', error);
            }
         );
   }
}
